import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';

import { environment } from 'src/environments/environment';

// Import facade
import { UserSettingFacade } from 'src/app/store/usersetting';
import { convert } from 'src/app/lib/roundOf';

declare let AOS: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent {
  originalTestimonials = [
    { name: 'Kiran K V', designation: 'USER', message: 'I’ve used multiple trading tools before, but nothing felt as effortless as CredBull’s DCA Bot. It picks entries smartly and manages risk better than most manual traders. The best part? I can watch it work in real-time without giving up wallet control. Solid product!',   image: 'assets/images/Kiran K V.jpg'},
    { name: 'Jayaram', designation: 'USER', message: 'CredBull changed the way I look at crypto. Earlier, I was just holding coins with no real plan. Now, with their trading bots, my USDT is actively growing without me doing anything. Simple and smart!', image: 'assets/images/Jayaram.jpg' },
    { name: 'Nandini', designation: 'USER', message: 'CredBull was referred by a friend. At first, I was just curious. But now, I’ve started referring others myself! The referral rewards and the steady returns make it worth it.', image: 'assets/images/girl.png'},
    { name: 'Sanjeev', designation: 'USER', message: 'Honestly, I didn’t believe in bots before. But CredBull proved me wrong. I’ve seen consistent results for the past 40 days. And the fact that I keep full control of my funds makes it even better.', image: 'assets/images/Sanjeev.jpg' },
    { name: 'Ramyashree', designation: 'USER', message: 'I may not be from a tech background, but CredBull made everything easy to understand. As a senior user, I truly appreciate how smooth the bot trading experience has been. No confusion, no pressure — just consistent performance and a support team that actually listens.', image: 'assets/images/girl.png'},
  ];
  convert = convert

  activeTheme = localStorage.getItem('theme')
  slides: string[] = [];
  sliderurl: string = ''
  cmsurl: string = environment.userApiUrl + 'cms-images/'
  whydarkimage: string = ''
  slideConfig = {
    "slidesToShow": 4,
    "slidesToScroll": 1,
    "dots": false,
    "infinite": true,
    "arrows": false,
    "autoplay": true,
    "autoplaySpeed": 2000,
    "loop": true,
    "responsive": [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  };

  homeCustomerServed: any = {}
  homeServingBc: any = {}
  homeOrderProcessed: any = {}
  homeCoutries: any = {}
  homeimageBanner: any = {}
  homeimageWhyChoose: any = {}
  homeimageMobileApp: any = {}
   visibleTestimonials: any[] = [];
  currentSlide = 1;
  slideWidth = 100 / 3;
  enableTransition = true;
  intervalId: any;


  constructor(private commonService: CommonService, private userSettingFacade: UserSettingFacade) { }
  slickInit(e: any) {
    // console.log('slick initialized');
  }

  ngOnInit() {

    this.setupLoop();
    this.startAutoSlide();

    AOS.init();
    AOS.refresh();
    this.getCmsContent()
    this.getSliders()

    this.userSettingFacade.usersetting$
      .subscribe({
        next: (data: any) => {
          let image_name = 'cms-why_choose_img_dark.png';
          if (data.defaultTheme == 'light')
            image_name = 'cms-why_choose_img_light.png'

          this.whydarkimage = this.cmsurl + image_name
        },
        error: (err) => console.log(err)
      })
  }

  
  ngOnDestroy() {
    clearInterval(this.intervalId);
  }

  setupLoop() {
    const first = this.originalTestimonials.slice(0, 3);
    const last = this.originalTestimonials.slice(-3);
    this.visibleTestimonials = [...last, ...this.originalTestimonials, ...first];
    this.currentSlide = 3; // Start from the real first slide
  }

  next() {
    if (this.currentSlide < this.visibleTestimonials.length - 3) {
      this.currentSlide++;
    }
    this.enableTransition = true;

    // Reset position to start
    if (this.currentSlide === this.visibleTestimonials.length - 3) {
      setTimeout(() => {
        this.enableTransition = false;
        this.currentSlide = 3;
      }, 600); // Match CSS transition duration
    }
  }

  prev() {
    if (this.currentSlide > 0) {
      this.currentSlide--;
    }
    this.enableTransition = true;

    // Reset to end
    if (this.currentSlide === 0) {
      setTimeout(() => {
        this.enableTransition = false;
        this.currentSlide = this.visibleTestimonials.length - 6;
      }, 600);
    }
  }

  startAutoSlide() {
    this.intervalId = setInterval(() => {
      this.next();
    }, 4000);
  }

  getSliders() {
    this.commonService.getSliders()
      .subscribe({
        next: (v: any) => {

          const result = v.result

          if (result && result.length > 0) {
            this.sliderurl = environment.userApiUrl + 'slider/'
            const list: string[] = []
            result.forEach((element: any) => {
              list.push(element.image)
            });
            this.slides = list
            // console.log(list, 'list')
          }
        },
        error: () => { }
      })
  }

  getCmsContent() {
    this.commonService.getHomeCmsPages()
      .subscribe({
        next: (v: any) => {
          const result = v.result
          if (result && result.length > 0) {
            result.map((item: any) => {
              if (item.identifier == "home-customers-served") {
                this.homeCustomerServed = item
              } if (item.identifier == "home-serving-bc") {
                this.homeServingBc = item
              } if (item.identifier == "home-order-processed") {
                this.homeOrderProcessed = item
              } if (item.identifier == "home-coutries") {
                this.homeCoutries = item
              } if (item.identifier == "homeimage-banner") {
                this.homeimageBanner = item
              } if (item.identifier == "homeimage-why_choose_image") {
                this.homeimageWhyChoose = item
              } if (item.identifier == "homeimage-mobile-app") {
                this.homeimageMobileApp = item
              }
            })
          }
        },
        error: (err) => {
          // console.log(err)
        }
      })
  }

}
